import { IQuestionModel } from '@care-portals/api-interfaces';
import { IMAGE_TYPES } from '../../constants';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Please upload a clear photo showing your full body.',
    field: 'bodySelfieUs',
    type: 'file_upload',
    accepts: IMAGE_TYPES,
    answer: [
      {
        resourceId: 'bodySelfieUs',
        buttonLabel: 'Body image'
      }
    ]
  }
];

export default questionsModels;
